import { fromEnumAsString } from '../../../serialization/enum-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../../dto/dto.js';
import { LegacyOrderHook, LegacyOrderHookId } from '../legacy-order-hook.js';
import { OrderSideEffectType } from './order-side-effect-type.js';
import { OrderSideEffect } from './order-side-effect.js';

export class SendOnlyPaymentConfirmationSideEffect extends OrderSideEffect {
  static readonly TYPE_ID: string = '8fdbdfdf5e294fdb9e698f26e049094f';

  public readonly effectType: OrderSideEffectType = OrderSideEffectType.SendOnlyPaymentConfirmation;

  private constructor() {
    super();
  }

  get $typeId(): string {
    return SendOnlyPaymentConfirmationSideEffect.TYPE_ID;
  }

  static create(): SendOnlyPaymentConfirmationSideEffect {
    return new SendOnlyPaymentConfirmationSideEffect();
  }

  static fromMap(context: SerializationContext, map: SerializedData): SendOnlyPaymentConfirmationSideEffect {
    return new SendOnlyPaymentConfirmationSideEffect();
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'effectType': fromEnumAsString(this.effectType),
    };
  }

  clone(): this {
    return new SendOnlyPaymentConfirmationSideEffect() as this;
  }

  isSame(other: SendOnlyPaymentConfirmationSideEffect): boolean {
    if(this === other) {
      return true;
    }

    return other.effectType === this.effectType;
  }

  toLegacyOrderHook(): LegacyOrderHook {
    return LegacyOrderHook.create(LegacyOrderHookId.SendOnlyPaymentConfirmation);
  }

  static verifyType(order: DataModel): boolean {
    return order instanceof SendOnlyPaymentConfirmationSideEffect;
  }

  static assertType(order: DataModel): order is SendOnlyPaymentConfirmationSideEffect {
    return order instanceof SendOnlyPaymentConfirmationSideEffect;
  }
}

export class SendOnlyPaymentConfirmationSideEffectBuilder extends DataModelBuilder<SendOnlyPaymentConfirmationSideEffect> {
  build(context: SerializationContext, map: SerializedData): SendOnlyPaymentConfirmationSideEffect {
    return SendOnlyPaymentConfirmationSideEffect.fromMap(context, map);
  }
}
